import Colors from 'library/constants/colors';
import {
  ColorButton,
  ColorPickerContainer,
  ColorsContainer,
  IconU,
  PickColorText,
  SetColorContainer,
  ResultSetContainer,
} from './styles';

const FolderColorPicker = ({
  label,
  onChange,
  value,
  name,
  inputRef,
  colors,
}) => {
  const getButtons = () => colors.map(
    (background) => (
      <ColorButton
        key={background}
        active={background === value}
        style={{ background }}
        onClick={(e) => {
          e.preventDefault();

          onChange(background);
        }}
      />
    ),
  );

  const inputValue = { color: value };

  return (
    <ColorPickerContainer>
      <ResultSetContainer>
        <IconU className="icon-folder-alt" style={inputValue} />
      </ResultSetContainer>
      <SetColorContainer>
        <PickColorText>{label}</PickColorText>
        <ColorsContainer>
          {getButtons()}
        </ColorsContainer>
      </SetColorContainer>
      <input type="hidden" ref={inputRef} name={name} />
    </ColorPickerContainer>
  );
};

export default FolderColorPicker;
